export enum StoreKeyEnum {
  token = 'user_dto',
}
